import { render, staticRenderFns } from "./CampaignContactsSaveSegmentModal.vue?vue&type=template&id=1f123614&scoped=true&"
import script from "./CampaignContactsSaveSegmentModal.vue?vue&type=script&lang=js&"
export * from "./CampaignContactsSaveSegmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f123614",
  null
  
)

export default component.exports